import { type SVGProps, useState } from 'react';

/** Icon set ported 1:1 from mockups/assets/core.js (same names, same paths). */
const P = {
  home: 'M3 11l9-7 9 7v9a1 1 0 01-1 1h-5v-6H9v6H4a1 1 0 01-1-1z',
  chat: 'M5 19l1.3-3.9A8 8 0 1112 20a8 8 0 01-3.6-.9z',
  users: 'M9 11.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M16 4.5a3.5 3.5 0 010 7M21 20c0-2.6-1.7-4.9-4-5.7',
  groups: 'M4 5h16a1 1 0 011 1v12a1 1 0 01-1 1H4a1 1 0 01-1-1V6a1 1 0 011-1zM7 10h10M7 14h6',
  list: 'M4 6h16M4 12h16M4 18h10',
  pulse: 'M3 12h4l3-7 4 14 3-7h4',
  settings: 'M12 15a3 3 0 100-6 3 3 0 000 6zM12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9L7 7M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1',
  plus: 'M12 5v14M5 12h14',
  search: 'M11 18a7 7 0 100-14 7 7 0 000 14zM20 20l-3.5-3.5',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  x: 'M6 6l12 12M18 6L6 18',
  alert: 'M12 3l10 18H2zM12 10v5M12 18v.01',
  info: 'M12 22a10 10 0 100-20 10 10 0 000 20zM12 11v6M12 7.5v.01',
  clock: 'M12 22a10 10 0 100-20 10 10 0 000 20zM12 7v5l3 2',
  power: 'M12 3v9M6.3 6.3a8 8 0 1011.4 0',
  refresh: 'M20 11a8 8 0 10-2.3 5.7M20 4v7h-7',
  copy: 'M9 9h10v10H9zM5 15V5h10',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12zM12 15a3 3 0 100-6 3 3 0 000 6z',
  edit: 'M4 20h4L19 9l-4-4L4 16zM14 6l4 4',
  link: 'M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1',
  key: 'M15 9a4 4 0 11-2.8 6.8L9 19H6v-3H3v-3l5.2-5.2A4 4 0 0115 9zM16 8.5v.01',
  mail: 'M3 6h18v12H3zM3 7l9 6 9-6',
  send: 'M21 3L10 14M21 3l-7 18-4-7-7-4z',
  sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 16l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z',
  calendar: 'M4 6h16v14H4zM4 10h16M9 3v4M15 3v4',
  sun: 'M12 17a5 5 0 100-10 5 5 0 000 10zM12 1v2M12 21v2M1 12h2M21 12h2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
  moon: 'M21 13A9 9 0 1111 3a7 7 0 0010 10z',
  menu: 'M4 7h16M4 12h16M4 17h16',
  chevron: 'M15 6l-6 6 6 6',
  chevronL: 'M9 6l6 6-6 6',
  phone: 'M7 3h10v18H7zM11 18h2',
  shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z',
  filter: 'M4 5h16l-6 8v6l-4-2v-4z',
  play: 'M7 5l12 7-12 7z',
  wand: 'M4 20L15 9M14 4v3M18 6l-2 2M20 10h-3M13 4l1 1',
  inherit: 'M7 4v9a4 4 0 004 4h9M16 13l4 4-4 4',
  flask: 'M9 3h6M10 3v6L4 19a1 1 0 00.9 1.5h14.2A1 1 0 0020 19L14 9V3',
  download: 'M12 4v11M7 10l5 5 5-5M5 20h14',
  trash: 'M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3',
  globe: 'M12 22a10 10 0 100-20 10 10 0 000 20zM2 12h20M12 2c3 3 3 17 0 20M12 2c-3 3-3 17 0 20',
  bolt: 'M13 2L4 14h7l-1 8 9-12h-7z',
} as const;

export type IconName = keyof typeof P;

export function Icon({ name, ...rest }: { name: IconName } & SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...rest}
    >
      <path d={P[name] ?? P.info} />
    </svg>
  );
}

/** Butterfly mark from the mockups (used in WhatsApp preview avatars). */
export function Logo({ size = 26, fill = '#FFD600', body = '#2B1550' }: { size?: number; fill?: string; body?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <g fill={fill}>
        <ellipse cx="10" cy="11" rx="6" ry="7.5" transform="rotate(-28 10 11)" />
        <ellipse cx="22" cy="11" rx="6" ry="7.5" transform="rotate(28 22 11)" />
        <ellipse cx="11.5" cy="21.5" rx="4" ry="5" transform="rotate(25 11.5 21.5)" />
        <ellipse cx="20.5" cy="21.5" rx="4" ry="5" transform="rotate(-25 20.5 21.5)" />
      </g>
      <path d="M16 8v18" stroke={body} strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

// Official NIVISION logos (D-70), hotlinked from nivision.co.il (no local copy until Orel approves a download).
export const LOGO_URL = {
  white: 'https://nivision.co.il/wp-content/uploads/2026/02/Nivision-logo.png',
  purple: 'https://nivision.co.il/wp-content/uploads/2025/11/Nivision-dark@3x-scaled.png',
} as const;

/** Logo image; if the hotlink is blocked/offline it falls back to the word "NIVISION" so the shell never breaks. */
export function BrandImg({ variant = 'white', height = 28 }: { variant?: keyof typeof LOGO_URL; height?: number }) {
  const [failed, setFailed] = useState(false);
  if (failed) {
    return (
      <span className={`brand-logo brand-text ${variant}`} role="img" aria-label="NIVISION" style={{ height, fontSize: Math.round(height * 0.62) }}>
        NIVISION
      </span>
    );
  }
  return <img className="brand-logo" src={LOGO_URL[variant]} alt="NIVISION" style={{ height }} referrerPolicy="no-referrer" onError={() => setFailed(true)} />;
}
